/* Personliga systemadmin-verktyg (t.ex. ETF-allokering).

   Beslut Mikael 2026-10-01: sådana vyer ska BARA synas för plattformens
   systemadmin och aldrig förekomma i någon annan information — inte för
   organisationsadministratörer, inte i sök, favoriter eller hemguide.

   Strikt kontroll: rollen måste vara exakt "systemadmin". Den bredare
   menyregeln i Layout räknar även den äldre rollen "admin" (som i backend
   sedan 2026-08-06 betyder organisationsadministratör) och duger därför
   inte här. Under användarsimulering döljs vyerna, så att det man ser
   motsvarar den simulerade personen. */
export function arSystemadminUtanSimulering(user) {
  // Samma regel som isSystemAdminUser i modules/SystemAdmin/systemAdminShared.js
  // (och backendens auth_deps.is_admin): rollen systemadmin, eller is_admin === true.
  const arSystemadmin = user?.is_admin === true || String(user?.role || '').trim().toLowerCase() === 'systemadmin';
  if (!arSystemadmin) return false;
  try {
    if ((localStorage.getItem('kanplan-simulated-user') || '').trim()) return false;
    if ((localStorage.getItem('kanplan-simulated-role') || '').trim()) return false;
  } catch {
    /* localStorage otillgängligt — ingen simulering möjlig */
  }
  return true;
}
